(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name components.directive:neoPrintCardTemplate
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="components">
   <file name="index.html">
   <neo-print-card-template></neo-print-card-template>
   </file>
   </example>
   *
   */
  angular
      .module('neo')
      .directive('neoPrintInvoiceTemplate', neoPrintInvoiceTemplate);

  function neoPrintInvoiceTemplate() {
    return {
      restrict: 'E',
      scope: {
        persona2: '='
      },
      templateUrl: 'directives/neo-print-invoice-template/neo-print-invoice-template-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: function ($scope,scope) {
        var vm = this;
        vm.name = 'neoPrintInvoiceTemplate';
    // $scope.persona2=scope.persona2;
      
      },
      link: function (scope, element, attrs) {
           
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
